// src/components/AdsSection.tsx
import React, { useEffect, useState } from 'react';

interface Ad {
  id: number;
  contentUrl: string;
  linkUrl: string;
  section: string;
}

const AdsSection: React.FC = () => {
  const [ads, setAds] = useState<Ad[]>([]);
  const API_BASE_URL = 'http://localhost:2026';

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/ads`)
      .then((res) => res.json())
      .then((data) => {
        const bottomAds = data.filter((ad: Ad) => ad.section === 'bottom');
        setAds(bottomAds.slice(0, 3));
      })
      .catch((err) => console.error('Error fetching ads:', err));
  }, []);

  if (ads.length === 0) return null;

  return (
    <div
      className="
        relative z-10 w-full
        px-2 lg:px-4
        -mt-12 sm:-mt-14 lg:-mt-20 xl:-mt-28 2xl:-mt-36
        lg:pl-[270px]
        mb-6
      "
    >
      <div
        className="
          flex md:grid md:grid-cols-3
          gap-3
          w-full max-w-[2000px]
          overflow-x-auto md:overflow-visible
          no-scrollbar
        "
      >
        {ads.map((ad) => (
          <a
            key={ad.id}
            href={ad.linkUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="
              block flex-shrink-0
              w-[95%] md:w-full
              rounded-lg overflow-hidden
              bg-white
              border border-gray-100
              shadow-sm hover:shadow-md
              transition-all duration-300
              group
            "
          >
            <div className="h-[150px] lg:h-[160px] bg-gray-50 overflow-hidden">
              <img
                src={`${API_BASE_URL}${ad.contentUrl}`}
                alt="Promotion"
                className="
                  w-full h-full
                  object-cover
                  transition-transform duration-500
                  group-hover:scale-105
                "
                onError={(e) =>
                  (e.currentTarget.src =
                    'https://via.placeholder.com/400x150?text=Offer+Image')
                }
              />
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default AdsSection;
